'use client';

import React, { ChangeEvent } from 'react';
import { IMask, IMaskInput } from 'react-imask';

import { FormGroup } from '../../templates';
import type { PhoneInputProps } from './phone-input.types';

function getContainerStyle(withButton: boolean) {
  if (withButton)
    return 'hc-input__container--with-button hc-sidebar-layout--reverse';

  return '';
}

export function PhoneInput({
  label,
  placeholder = '(000) 000-0000',
  required = false,
  disabled = false,
  errorText = '',
  icon = null,
  helpText = '',
  error = false,
  name = 'phone_number',
  id,
  withButton = false,
  button,
  className,
  onChange,
  onBlur,
  defaultValue,
  ref,
  'data-testid': dataTestId,
}: PhoneInputProps & {
  ref?: React.Ref<HTMLInputElement>;
}) {
  const showErrors = error;
  const inputId = id || name;

  return (
    <FormGroup className={className} disabled={disabled} error={showErrors}>
      <label className="hc-label" htmlFor={inputId}>
        {label}
      </label>
      <div className={getContainerStyle(withButton)}>
        <div className="hc-form-control--icon-right relative">
          <IMaskInput
            onBlur={onBlur}
            onAccept={(_v, _r, e) => {
              if (e) {
                // Required to work with react hook form as IMask Uses onAccept instead of onChange.
                onChange?.(e as unknown as ChangeEvent<HTMLInputElement>);
              }
            }}
            inputRef={ref}
            mask={
              new IMask.MaskedPattern({
                mask: '(000) 000-0000',
              })
            }
            lazy={false}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            name={name}
            id={inputId}
            aria-invalid={showErrors}
            defaultValue={defaultValue}
            type="tel"
            data-testid={dataTestId ?? 'core-phone-input'}
          />
          {icon}
        </div>
        {button}
      </div>
      <div className="hc-help-text">{helpText}</div>
      <div className="hc-error-text">{errorText}</div>
    </FormGroup>
  );
}
